import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Layout } from 'antd';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import LeadList from './components/LeadList';
import LeadsFilters from './components/LeadsFilters';
import { checkPermissionsHOC } from '../../App/CheckPermissions';
import { NotFound } from '../../App/components/NotFound';
import { LEADS_ROUTE } from './contants/routes.contants';
import { checkIsLeadManageDeliveryRequested, checkIsLeadManageLeadomatic } from './utils';

const VIEW_PERMISSION_URL_PREFIX = 'view:/';
const LEADS_MANAGE_VIEW = `${VIEW_PERMISSION_URL_PREFIX}${LEADS_ROUTE.LEADS_MANAGE}`;
const LEADS_MANAGE_LEADOMATIC_VIEW = `${VIEW_PERMISSION_URL_PREFIX}${LEADS_ROUTE.LEADS_MANAGE_LEADOMATIC}`;
const LEAD_CREATE_VIEW = `${VIEW_PERMISSION_URL_PREFIX}${LEADS_ROUTE.LEAD_CREATE}`;
const LEAD_PROFILE_VIEW = `${VIEW_PERMISSION_URL_PREFIX}${LEADS_ROUTE.LEAD_PROFILE}`;
const LEAD_MANAGE_DELIVERY_REQUESTED_VIEW = `${VIEW_PERMISSION_URL_PREFIX}${LEADS_ROUTE.LEAD_MANAGE_DELIVERY_REQUESTED}`;

// One module, retails and leadomatic 'differ in division, tabs, and default active filter'

class Index extends Component {
    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_PERMISSIONS' });
    }

    render() {
        const { views_permissions } = this.props;

        const lead_create_access = views_permissions[LEAD_CREATE_VIEW];
        const lead_profile_access = views_permissions[LEAD_PROFILE_VIEW];
        const isLeadManageLeadomatic = checkIsLeadManageLeadomatic();
        const isLeadManageDeliveryRequested = checkIsLeadManageDeliveryRequested();

        let pageTitleText = ' leads';
        let permission = LEADS_MANAGE_VIEW;

        switch (true) {
        case isLeadManageLeadomatic:
            pageTitleText = `Leadomatic${pageTitleText}`;
            permission = LEADS_MANAGE_LEADOMATIC_VIEW;
            break;
        case isLeadManageDeliveryRequested:
            pageTitleText = `'Delivery Requested'${pageTitleText}`;
            permission = LEAD_MANAGE_DELIVERY_REQUESTED_VIEW;
            break;
        default:
            pageTitleText = `Retail${pageTitleText}`;
        }

        const view_parent_access = views_permissions[permission];
        const pageDescText = isLeadManageDeliveryRequested ? '' : `Manage ${isLeadManageLeadomatic ? 'leadomatic' : 'retail'} leads for the Super Bike Factory platform`;

        if (!view_parent_access) {
            return <NotFound />;
        }

        return (
            <Layout className="lead-manage-container">
                <Row>
                    <Col span={24}>
                        <div>
                            <h3 className="page-title">{pageTitleText}</h3>
                            <h3 className="page-subhead subhead">{pageDescText}</h3>
                        </div>
                    </Col>
                </Row>
                <Row style={{ marginBottom: 5 }}>
                    <Col span={21}>
                        <LeadsFilters
                            isLeadManageLeadomatic={isLeadManageLeadomatic}
                            isLeadManageDeliveryRequested={isLeadManageDeliveryRequested}
                        />
                    </Col>
                    <Col span={3}>
                        {!isLeadManageDeliveryRequested && (
                            <div style={{ marginTop: '5px' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    disabled={!lead_create_access}
                                    style={{ float: 'right' }}
                                >
                                    <Link style={{ color: '#fff' }} to="/Leads/Lead_create">Add Lead</Link>
                                </Button>
                            </div>
                        )}
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <LeadList
                            parent={this}
                            lead_profile_access={!lead_profile_access}
                            isLeadManageLeadomatic={isLeadManageLeadomatic}
                            isLeadManageDeliveryRequested={isLeadManageDeliveryRequested}
                        />
                    </Col>
                </Row>
            </Layout>
        );
    }
}

const mapStateToProps = (state) => ({
    views_permissions: state.App.Permissions.views_permissions,
    loading: state.Leads.Leads_manage.loading,
});

export default connect(
    mapStateToProps,
    (dispatch) => ({ dispatch }),
)(checkPermissionsHOC(
    Index,
    [
        LEADS_MANAGE_VIEW,
        LEADS_MANAGE_LEADOMATIC_VIEW,
        LEAD_CREATE_VIEW,
        LEAD_PROFILE_VIEW,
        LEAD_MANAGE_DELIVERY_REQUESTED_VIEW,
    ],
));



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/index.js